/*
 * StyleMyScreens V30A_84
 * Smooth 1-second local generation progress UI.
 * Server polling remains controlled by the Liquid code, normally every 5 seconds.
 */
(function () {
  var timer = null;
  var state = {
    active: false,
    mode: 'idle',
    startedAt: 0,
    estimateText: 'Usually 1-2 mins',
    estimateSeconds: 120,
    maxPollingSeconds: 360,
    preparingText: 'Preparing your photos...',
    preparingSubText: 'Please keep this page open.',
    lastRenderedSecond: null
  };

  function parsePositiveInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return !isNaN(parsed) && parsed > 0 ? parsed : fallback;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function mergeConfig(config) {
    config = config || {};

    if (config.estimateText) {
      state.estimateText = String(config.estimateText);
    }

    if (config.preparingText) {
      state.preparingText = String(config.preparingText);
    }

    if (config.preparingSubText) {
      state.preparingSubText = String(config.preparingSubText);
    }

    state.estimateSeconds = parsePositiveInt(config.estimateSeconds, state.estimateSeconds || 120);
    state.maxPollingSeconds = parsePositiveInt(config.maxPollingSeconds, state.maxPollingSeconds || 360);

    if (config.startedAt) {
      var startedAt = parseInt(config.startedAt, 10);
      if (!isNaN(startedAt) && startedAt > 0) {
        state.startedAt = startedAt;
      }
    }
  }

  function getElapsedSeconds(fallbackSeconds) {
    if (state.active && state.startedAt > 0) {
      return Math.max(0, Math.floor((Date.now() - state.startedAt) / 1000));
    }

    var parsed = parseInt(fallbackSeconds, 10);
    return isNaN(parsed) ? -9999 : parsed;
  }

  function render(seconds) {
    var loading = document.getElementById('loading');
    var loadingUnder = document.getElementById('loadingUnder');
    var progressWrap = document.getElementById('loadingProgressWrap');
    var progressBar = document.getElementById('loadingProgressBar');

    var parsedSeconds = parseInt(seconds, 10);
    var hasSeconds = !isNaN(parsedSeconds) && parsedSeconds >= 0;
    var isPreparing = state.mode === 'preparing';

    if (progressWrap && progressBar) {
      var percent = 8;

      if (isPreparing) {
        var preparingSeconds = hasSeconds ? parsedSeconds : 0;
        var loopPercent = 12 + ((preparingSeconds % 12) / 11) * 48;
        percent = Math.max(12, Math.min(60, loopPercent));
      } else if (hasSeconds) {
        percent = Math.max(8, (parsedSeconds / state.estimateSeconds) * 100);
        if (state.active) {
          percent = Math.min(95, percent);
        } else {
          percent = Math.min(100, percent);
        }
      }

      progressWrap.style.display = 'block';
      progressBar.classList.add('sms-progress-active');
      progressBar.style.width = percent + '%';
    }

    if (loading) {
      loading.style.display = 'block';

      // V30A_84: During the generating phase, do not overwrite the main loading
      // message every 1 second. The Liquid polling flow already rotates through
      // the curated random loading messages. Only the preparing phase owns this line.
      if (isPreparing) {
        loading.innerText = '📷 Preparing your photos...';
      }
    }

    if (!loadingUnder) {
      return;
    }

    loadingUnder.style.display = 'block';

    if (isPreparing) {
      if (hasSeconds && parsedSeconds >= 10) {
        loadingUnder.innerHTML = 'Still preparing photos... Please keep this page open.';
        return;
      }

      loadingUnder.innerHTML = escapeHtml(state.preparingText) + ' ' + escapeHtml(state.preparingSubText);
      return;
    }

    if (hasSeconds && parsedSeconds > state.maxPollingSeconds) {
      loadingUnder.innerHTML = 'Taking longer than usual due to high demand.';
      return;
    }

    if (hasSeconds && parsedSeconds > 0) {
      loadingUnder.innerHTML = 'Processing for ' + parsedSeconds + 's. ' + escapeHtml(state.estimateText) + '.';
      return;
    }

    if (!isNaN(parsedSeconds) && parsedSeconds < 0 && parsedSeconds > -9999) {
      loadingUnder.innerHTML = 'Taking longer than usual.';
      return;
    }

    loadingUnder.innerHTML = 'Creating your preview. ' + escapeHtml(state.estimateText) + '.';
  }

  function tick() {
    render(getElapsedSeconds(-9999));
  }

  function ensureTimer() {
    if (timer) {
      return;
    }

    timer = window.setInterval(tick, 1000);
  }

  function start(config) {
    mergeConfig(config);

    if (!state.startedAt) {
      state.startedAt = Date.now();
    }

    state.mode = 'generating';
    state.active = true;
    tick();
    ensureTimer();
  }

  function startPreparing(config) {
    mergeConfig(config);
    state.mode = 'preparing';
    state.startedAt = Date.now();
    state.active = true;
    tick();
    ensureTimer();
  }

  function update(seconds, config) {
    mergeConfig(config);

    if (state.active) {
      tick();
      return;
    }

    render(seconds);
  }

  function stop(hide) {
    state.active = false;
    state.mode = 'idle';
    state.startedAt = 0;
    state.lastRenderedSecond = null;

    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }

    if (hide === false) {
      return;
    }

    var progressWrap = document.getElementById('loadingProgressWrap');
    var progressBar = document.getElementById('loadingProgressBar');

    if (progressWrap) {
      progressWrap.style.display = 'none';
    }

    if (progressBar) {
      progressBar.classList.remove('sms-progress-active');
      progressBar.style.width = '0%';
    }
  }

  function complete() {
    var progressWrap = document.getElementById('loadingProgressWrap');
    var progressBar = document.getElementById('loadingProgressBar');

    if (progressWrap && progressBar) {
      progressWrap.style.display = 'block';
      progressBar.classList.add('sms-progress-active');
      progressBar.style.width = '100%';
    }

    stop(false);
  }

  window.SMSGenerationProgress = {
    start: start,
    startPreparing: startPreparing,
    update: update,
    stop: stop,
    complete: complete
  };
})();
